import { gql } from '@efficiently/client-core-graphql-models';

export const DOWNLOAD_PLAN_PDF = gql(`
	mutation DownloadPlanPdf($projectId: String!, $versionId: String, $type: PlanType) {
		downloadPlanPdf(projectId: $projectId, versionId: $versionId, type: $type) {
			planVersionName
			pdfUrls
		}
	}
`);
